import PropTypes from 'prop-types';

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ExpandableSectionHeader = ({
  sectionTitle, showSection, icon, collapseValues, setCollapseValue,
}) => {
  return (
    <Grid size={{ xs: 12 }}>
      <Box
        sx={{
          display: 'flex',
          cursor: 'pointer',
          justifyContent: 'space-between',
        }}
        onClick={() =>
          setCollapseValue(prev => ({
            ...prev,
            [showSection]: !prev?.[showSection]
          }))
        }
      >
        <Box display={'flex'}>
          <Box mt={0.6}>
            {icon}
          </Box>
          <Typography
            variant="h6"
            component='h6'
            ml={1.5}
            sx={{ color: '#1e293b' }}
          >
            <strong>{sectionTitle}</strong>
          </Typography>
        </Box>
        <Box mt={0.6}>
          {
            collapseValues?.[showSection] ?
              <KeyboardArrowDownIcon sx={{ color: '#64748b' }} />
              :
              <KeyboardArrowRightIcon sx={{ color: '#64748b' }} />
          }
        </Box>
      </Box>
    </Grid>
  );
};

ExpandableSectionHeader.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  showSection: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  collapseValues: PropTypes.object,
  setCollapseValue: PropTypes.func.isRequired,
};

export default ExpandableSectionHeader;